
export const environment = {
    baseUrl : "https://imsapi-dev.azurewebsites.net/api",
    akamaiUrl: "https://digitalam-cdt.apmterminals.com/inventory/ims-web/",
    production: false,
    msalConfig: {
        auth: {
            clientId: '0ec4c212-acb2-4aef-876a-6e44f88ae7de',
            authority: 'https://login.microsoftonline.com/05d75c05-fa1a-42e7-9cf1-eb416c396f2d'
        }
    },
    apiConfig: {
        scopes: ['api://0ec4c212-acb2-4aef-876a-6e44f88ae7de/Access'],
        uri: 'https://graph.microsoft.com/v1.0/me',
        scope: 'api://0ec4c212-acb2-4aef-876a-6e44f88ae7de/Access'
    },
    rumConfig: {
    appName: "IMS-Dev",
    apiKey: "4fwiJaDHm/TJwa1W7z624RTubfOHZSBQSZQ53B0kdk0gR0+szAfkSAwM0zHlmQ==",
  },
    gtmContainerId: 'GTM-M44QCF38'
  };
